module.exports = __webpack_public_path__ + "static/media/img2-1.dd8c7bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/biosense/diff/img2-1.png
// module id = 1979
// module chunks = 3